import React from 'react';
import GenericSectionDashboard from '../GenericSectionDashboard';

const WeavingDashboard = () => (
  <GenericSectionDashboard
    sectionName="Weaving Section"
    sectionId="weaving"
    sectionKey="Weaving Section"
    description="Parcels & documents received for Weaving"
    backRoute="/"
  />
);

export default WeavingDashboard;
